import OpenpayMixin from './OpenpayMixin'

export default {
    mixins: [
        OpenpayMixin
    ]
}